const errorMessages = {
  "hcp-lifesupport1-limits": `Please select at least one of the artificial methods, or change your life support answer to "no."`,
};

export default errorMessages;
